import { LeaderboardActionPointState } from './types';
import { LeaderboardActions, LeaderboardMultiplier } from '@/types/leaderboard.types';

// initial leaderboard action data set
// If event hasn't set leaderboard actions before, we need a default empty state to intialize with
// default state is every standard action turned off with a multiplier assignment of 1
// can't default in reducer because we need an event ID to set the actions
export const getInitialData = (eventId: number | undefined): LeaderboardMultiplier[] => {
  if (eventId) {
    return [
      { action: LeaderboardActions.registered, is_on: false, event_id: eventId, multiplier: 1 },
      { action: LeaderboardActions.quiz_answer_correct, is_on: false, event_id: eventId, multiplier: 1 },
      { action: LeaderboardActions.watched_minute, is_on: false, event_id: eventId, multiplier: 1 },
    ];
  }

  return [];
};

export const initialState: LeaderboardActionPointState = {
  fetchingError: false,
  loadingActions: false,
  mainActionsOn: [],
};
